define('HomepagePopUp.View', [
  'homepage_pop_up.tpl',
  'SCView'
],

function (
  Template,
  SCViewComponent
) {

  'use strict';

  var SCView = SCViewComponent.SCView;

  function HomepagePopUp(options) {

    SCView.call(this);

    this.options = options || {};

    this.template = Template;

    this.initialize = function initialize(opts) {
      this.popUpConfig = opts.popUpConfig;
    };

    this.initialize(options);

  }

  HomepagePopUp.prototype = Object.create(SCView.prototype);

  HomepagePopUp.prototype.constructor = HomepagePopUp;

  HomepagePopUp.prototype.getContext = function getContext() {
    return {
      title: this.popUpConfig ? this.popUpConfig.title : '',
      mainText: this.popUpConfig ? this.popUpConfig.mainText : '',
      buttonText: this.popUpConfig ? this.popUpConfig.buttonText : '',
      buttonLink: this.popUpConfig ? this.popUpConfig.buttonLink : '',
      imageUrl: this.popUpConfig ? this.popUpConfig.imageUrl : '',
      showSection: this.popUpConfig ? this.popUpConfig.activeDeactivate : false,
      redirectMyAccount: this.popUpConfig ? this.popUpConfig.redirectMyAccount : false
    };
  };

  return HomepagePopUp;
}
);
